// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/layout/Layout.css */
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  padding-top: 80px; /* Ajusté pour la nouvelle hauteur de navbar (64px + marge) */
  background-color: var(--color-gray-50);
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Layout.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB,EAAE,6DAA6D;EAChF,sCAAsC;AACxC","sourcesContent":["/* src/components/layout/Layout.css */\n.layout {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  padding-top: 80px; /* Ajusté pour la nouvelle hauteur de navbar (64px + marge) */\n  background-color: var(--color-gray-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
